module.exports = __webpack_public_path__ + "static/img/avator.400a374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avator.png
// module id = zA3t
// module chunks = 1